"use client";
import Link from "next/link";
import React from "react";

export default function RequestAQuoteButton() {
  return (
    <Link className="request-a-quote-button" href="#demo">
      Request a Demo
    </Link>
  );
}
